import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";
import { HTS_ISOLATED_OLD_INCIDENT_NOTE } from "./sharedNotes";

export const workplaceTrustConduct: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.WORKPLACE_TRUST_CONDUCT,
  label: "Trust and workplace conduct",
  kind: HtsTopicKind.Suitability,
  narrativeFields: [
    "what happened and in what role/employer context",
    "when it happened",
    "how it was discovered or came to light",
    "how it was resolved (warning, discipline, termination, restitution)",
    "what the candidate learned or changed since",
  ],
  followUpTriggers: [
    "the severity or scope of what was taken, disclosed, or misused is unclear",
    "there's no described resolution or outcome",
    "a complaint's outcome is unclear",
  ],
  hardBarrierFacts: [
    "unauthorized disclosure of confidential or private information involving vulnerable people or health records",
    "a confirmed misuse of a position of trust or authority for personal benefit",
  ],
  crossCuttingNotes: [
    HTS_ISOLATED_OLD_INCIDENT_NOTE,
    "a termination is the exception to the five-year note: always at least MARGINALLY_UNSUITABLE, however old, so a human reviews it",
    "a conduct issue at work within the last year (lateness, sleeping on shift and the like) is at least MARGINALLY_UNSUITABLE, however minor and however well explained",
    "covers: taking money or property from an employer without authorization, unauthorized disclosure of confidential/private information, misuse of a position of trust or authority, harassment/bullying/discrimination/violence complaints, being asked to leave a volunteer or caregiving position, and termination or a disciplinary letter",
    "a harassment/bullying/discrimination/violence complaint that never led to termination still counts — it's distinct from the termination question, since complaints that never led to termination still surface in reference checks",
    "volunteer history is often where conduct issues with vulnerable people first surface — treat an 'asked to leave' disclosure with the same weight as a workplace one",
  ],
};
